import React from "react";
import {CookieNotice} from "gatsby-cookie-notice";
import {useTranslation} from "gatsby-plugin-react-i18next";
import styled from "styled-components";

const CookieNoticeWrapper = styled.div`
  .gs-cookie {
    max-width: 394px;
    bottom: 20px;
    right: 20px;
    left: 20px;
    @media (min-width: 640px) {
      right: 20px;
      left: auto;
    }
  }

  .btn {
    width: 50%;
    height: 26px;
    font-size: 18px;
    line-height: 1.25;
    padding: 0;

    &:before {
      content: none;
    }

    &:hover {
      background-color: var(--bs-coral);
    }
  }

  .btn-hollow {
    color: var(--bs-primary);
    border: 2px solid var(--bs-primary);

    &:hover {
      background-color: var(--bs-coral);
      border-color: var(--bs-coral);
      color: var(--bs-linen);
    }
  }
`;
export const Cookie = () => {
  const {t} = useTranslation();

  return (
    <CookieNoticeWrapper>
      <CookieNotice
        backgroundClasses="p-16"
        personalizeButtonEnable={false}
        backgroundWrapperClasses="gs-cookie bg-linen border border-primary position-fixed z-2"
        declineButtonText={t('Decline')}
        acceptButtonText={t('Allow')}
        buttonWrapperClasses="d-flex flex-row-reverse gap-8"
        wrapperClasses="w-100"
        acceptButtonClasses="btn text-uppercase btn-primary btn-sm"
        declineButtonClasses="btn text-uppercase btn-hollow btn-sm"
        cookies={[
          {name: 'gatsby-gdpr-google-analytics', editable: true, default: true}
        ]}
      >
        <div className="d-flex align-items-start gap-16 mb-16">
          <img src="/images/cookie/heart.svg" width="70" height="75" alt="Icon"/>
          <p className="text-primary fs-22 lh-1 text-uppercase font-family-heading mb-0">
            {t('Cookie_text')}
          </p>
        </div>
      </CookieNotice>
    </CookieNoticeWrapper>
  )
}
